/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { Grid, Typography2 } from '@coursera/cds-core';
import type { Theme, TypographyProps } from '@coursera/cds-core';

const styles = {
  textWrapper: (theme: Theme) => css`
    flex: 70%;
    padding-right: ${theme.spacing(48)};
  `,
  bannerWrapper: (theme: Theme) => css`
    background-color: ${theme.palette.gray[100]};
    padding: ${theme.spacing(12)} ${theme.spacing(16)};
    border-radius: 4px;
  `,
};

type PropsFromCaller = {
  heading?: string | React.ReactNode;
  body: string | React.ReactNode;
  ctaContent?: React.ReactNode;
  customCss?: Interpolation<Theme>;
  typographyColor?: TypographyProps['color'];
};

type PropsToComponent = PropsFromCaller;

export const ProfileBanner = ({ heading, body, ctaContent, customCss, typographyColor }: PropsToComponent) => {
  return (
    <Grid container alignItems="center" justifyContent="space-between" css={[styles.bannerWrapper, customCss]}>
      <Grid item container direction="column" css={styles.textWrapper}>
        {heading && (
          <Typography2 component="h4" variant="subtitleMedium" color={typographyColor || 'supportText'}>
            {heading}
          </Typography2>
        )}
        <Typography2 component="p" color={typographyColor || 'supportText'}>
          {body}
        </Typography2>
      </Grid>
      {ctaContent}
    </Grid>
  );
};

export default ProfileBanner;
